import React, { SVGProps } from 'react';

const PresentIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 25 25"
			fill="none"
			{...props}
		>
			<g clipPath="url(#clip0_26992_148994)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.90039 4.68551C4.3905 1.86182 6.70866 -0.448185 9.51613 0.0741843C10.9831 0.346606 11.9073 1.36016 12.5005 2.65642C13.0936 1.36016 14.0178 0.346606 15.4848 0.0741843C18.2923 -0.448027 20.6106 1.86182 20.1006 4.68551C19.5043 7.9863 15.1969 8.46946 12.6094 8.73577H12.3925C9.80504 8.46851 5.49773 7.98535 4.90138 4.68551H4.90039ZM2.71176 25H11.4293V16.1481H2.12778C1.85846 16.1481 1.63947 16.3671 1.63947 16.6364V23.9288C1.63947 24.5199 2.11955 24.9999 2.71065 24.9999L2.71176 25ZM22.2903 25H13.5728V16.1481H22.8732C23.1426 16.1481 23.3616 16.3671 23.3616 16.6364V23.9288C23.3616 24.5199 22.8814 25 22.2903 25ZM5.26428e-05 10.665C5.26428e-05 10.0739 0.479102 9.59385 1.07123 9.59385H11.4283V14.5383L0.488312 14.5373C0.218984 14.5373 0 14.3183 0 14.049V10.664L5.26428e-05 10.665ZM13.5717 9.59385H23.9288C24.5209 9.59385 25 10.0739 25 10.665V14.05C25 14.3193 24.781 14.5383 24.5117 14.5383H13.5706V9.5938L13.5717 9.59385ZM13.7085 6.46069C15.0716 6.27771 17.7239 5.83261 17.9984 4.30916C18.241 2.96561 17.2295 1.92224 15.8694 2.17511C14.3541 2.45677 13.8915 5.09853 13.7086 6.45959L13.7085 6.46069ZM8.88298 5.93848C9.62623 6.1965 10.4836 6.35172 11.2916 6.46069C11.1086 5.09966 10.647 2.45779 9.13073 2.17621C7.76964 1.92333 6.75809 2.96671 7.00173 4.31027C7.14566 5.1059 7.92591 5.60756 8.88401 5.93959L8.88298 5.93848Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_26992_148994">
					<rect width="25" height="25" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default PresentIcon;
